import * as React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledLinear = styled(LinearProgress)(({ theme }) => ({
    height: "8px",
    borderRadius: "8px",
    backgroundColor: "#C6D9F6",
    "& .MuiLinearProgress-bar": {
        borderRadius: "8px",
        backgroundColor: "#4282E2",
    },
}));


export default function ImportProgress({
    label = "Importing comments",
    value = 56,
    progress
}) {
    const pillHalf = 24; // ~half of pill width

    return (
        <Box
            sx={{
                width: 375,
                ml: "auto",
                fontFamily: '"Source Sans Pro", sans-serif',
                border: "1px solid #C6D9F6",
                borderRadius: "4px",
                p: "6px 11px",
                pl: "11px",
                pr: "11px",
                display: "flex",
                alignItems: "center",
                mr: 4,
                gap: 2,
                bgcolor: "#F0F6FF",
            }}
        >
            <Typography sx={{ fontFamily: '"Open sans", sans-serif', color: "#2F6FE4", fontWeight: 600, lineHeight: "18px" }}>{label}</Typography>

            <Box sx={{ position: "relative", flex: 1 }}>
                <StyledLinear variant="determinate" value={progress} />
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        transform: "translateY(-50%)",
                        left: `calc(clamp(${pillHalf}px, ${progress}%, calc(100% - ${pillHalf}px)) - ${pillHalf}px)`,
                    }}
                >
                </Box>
            </Box>

            <Typography sx={{ fontFamily: '"Open sans", sans-serif', color: "#2F6FE4", fontWeight: 600, minWidth: 30, textAlign: "right" }}>
                {progress} %
            </Typography>
        </Box>
    );
}